import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Ao trocar de página, volta ao topo (endereços com #seção ficam por conta da própria página).
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
